(ns io.daskul.webapp.widgets.dashboard.trend-logic
  "Pure display logic for the Programs trend Δ (#945). The API sends a rounded
   :delta (nil when there aren't ≥3 fitted months). The sparkline colour AND the
   Δ arrow both derive from this one tone, so they can never disagree — retiring
   the old endpoint (last-vs-first) colouring.")

(defn trend-tone
  "Δ → tone. :up / :down / :flat drive teal / red / gray; :none (nil Δ) renders —."
  [delta]
  (cond
    (nil? delta) :none
    (pos? delta) :up
    (neg? delta) :down
    :else        :flat))
